import gql from 'graphql-tag';

export const QUERY_NUM_TERRITORIES_IN_TERRITORY_GROUP = gql`
  query GetNumberOfTerritoriesInTerritoryGroup($battlecardId: Int!, $territoryGroupId: Int) {
    getNumberOfTerritoriesInTerritoryGroup(battlecardId: $battlecardId, territoryGroupId: $territoryGroupId) {
      numOfTerritories
    }
  }
`;
